import CategoriesSection from "./CategoriesSection";
import HeroSectionNew from "./HeroSectionNew";
import ProcessingPlanSection from "./ProcessingPlanSection";
import StepsSection from "./StepsSection";

import backgroundImg from "../../../assets/home/bg_trong_dong_new.png";
import PopularCountriesSection from "./PopularCountriesSection";
import CustomerFeedbackSection from "./CustomerFeedbackSection";
import ReasonSection from "./ReasonSection";

const HomePage = () => {
  return (
    // p-8
    <div className="relative w-full flex flex-col">
      <img
        src={backgroundImg}
        alt=""
        className="absolute w-[60%] top-[17%] right-[20%] object-cover -z-10"
      />

      {/* <HeroSection /> */}
      <HeroSectionNew />

      <div className="w-full p-2 md:p-8 flex flex-col">
        <StepsSection />

        <CategoriesSection />

        <ProcessingPlanSection />

        <PopularCountriesSection />

        <CustomerFeedbackSection />

        <ReasonSection />

        {/* <LatestNewsSection /> */}
      </div>
    </div>
  );
};

export default HomePage;
